import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { AnalyticsStore, RouteStore } from 'bernie-core';
import { LocalizedText } from 'bernie-l10n';

import { classNames } from 'uitk-react-utils';
import { UitkPageLoader } from 'uitk-react-loader';
import { UitkSecondaryFloatingButton } from 'uitk-react-button';
import { UitkToast } from 'uitk-react-toast';

export interface MapSearchProps {
  routeStore?: RouteStore;
  analytics?: AnalyticsStore;
  messageDismissed: () => void;
  searchInProgress?: boolean;
  searchMessage?: string;
  showSearchButton?: boolean;
  center?: any;
  splitView?: boolean;
}

export interface MapSearchState {
  center?: any;
}

@inject('routeStore', 'analytics')
@observer
export class MapSearch extends React.Component<MapSearchProps, MapSearchState> {
  private trackMapSearch: () => void;

  public constructor(props) {
    super(props);
    this.setUpAnalyticsTrackers(props.analytics);

    this.onMapSearch = this.onMapSearch.bind(this);
  }

  public static defaultProps = {
    splitView: false
  };

  public render() {
    const { messageDismissed, searchInProgress, searchMessage, showSearchButton, splitView } = this.props;
    const mapViewerClasses = classNames('map-viewer__search', { 'splitview-map-height': splitView });

    return (
      <div className={mapViewerClasses}>
        <div className="map-viewer__search-button uitk-type-center">
          {(showSearchButton || searchInProgress) && (
            <UitkSecondaryFloatingButton className="elevation-4" disabled={searchInProgress} onClick={this.onMapSearch}>
              <LocalizedText message="maps.viewer.searchButton.text" />
            </UitkSecondaryFloatingButton>
          )}
        </div>
        <UitkToast show={!!searchMessage} onDismiss={messageDismissed}>
          {searchMessage}
        </UitkToast>
        <UitkPageLoader className="map-viewer__loader" visible={searchInProgress} />
      </div>
    );
  }

  private setUpAnalyticsTrackers(analytics) {
    const noop = () => null;
    let clickTracker;
    if (analytics && analytics.clickTracker) {
      clickTracker = analytics.clickTracker.bind(analytics);
      this.trackMapSearch = clickTracker('Module.Map.Search.Button', 'User clicking the map search button on PWA HSR Map', null, noop);
    } else {
      this.trackMapSearch = noop;
    }
  }

  private onMapSearch() {
    this.trackMapSearch();
    const { center } = this.props;
    const latLong = `${center.lat()},${center.lng()}`;
    this.props.routeStore.updateSearch({
      regionId: '',
      destination: '',
      selected: '',
      poi: '',
      latLong
    });
  }
}
